<template>
  <component :is="layout">
    <router-view />
    <v-snackbar v-model="snackbar" :color="color">{{ message }}</v-snackbar>
  </component>
</template>

<script>
import defaultLayout from "./layouts/Default";
import loginLayout from "./layouts/Login";
import store from "./store";

export default {
  name: "App",
  components: {
    defaultLayout,
    loginLayout
  },
  data: () => ({
    //
  }),
  computed: {
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
    snackbar: {
      get() {
        return store.snackbar;
      },
      set(value) {
        store.snackbar = value;
      }
    },
    color() {
      return store.snackbarSuccess ? "success" : "red";
    },
    message() {
      return store.snackbarMessage;
    }
  }
};
</script>
